import NiceModal from "@ebay/nice-modal-react";
import WalletModal, { type WalletModalProps } from "./modal";
import { type WalletEntrance } from "../../types";
import { safeCaptureExceptionFull } from "@/utils/sentry-utils";

export function showWalletModal(options: WalletModalProps = {}) {
  const promise = NiceModal.show(WalletModal, options);
  // 捕获 modal 内部的 Promise 级别异常，全采样上报（10+ 个调用处，统一在此处理）
  promise.catch((error: unknown) => {
    safeCaptureExceptionFull(
      error instanceof Error ? error : new Error(String(error)),
      (scope) => { scope.setTag('component', 'WalletModal'); return scope; }
    );
  });
  return promise;
}

export function hideWalletModal() {
  return NiceModal.hide(WalletModal);
}

export type { WalletEntrance, WalletModalProps };
